import createReducer from 'reducers/createReducer';

import { ShopGameRoundOptionSetting } from 'actions/actionTypes';

const INITIAL_STATE = {
  data: {
    concede: 1.25,
    holeCupLocation: 0,
    mulliganCount: 3,
    useSwingPlate: 0,
    distanceUnit: 0,
    greenLocation: 0,
    greenSpeed: 2,
    greenHardness : 0,
    windSpeed: 0,
    puttingLine: -1,
    isBestVideo: false,
    isContinuePutting: false,
    isCaddyVoice: false,
    isNoPuttMode: false,
    isUseObHazardTee: false,
    shotInfoLocation: 0,
    isUseGuideDistance: true,
    maxScoreFactor: 2,
  },
  error: {
    triggered: false,
    message: '',
  },
};

// 리듀서
const reducer = createReducer(INITIAL_STATE, {
  [ShopGameRoundOptionSetting.CHANGE_SHOP_GAME_ROUND_OPTION_SETTING_INFO]: (state, action) => {
    state.data[action.payload.name] = action.payload.value;
  },

  [ShopGameRoundOptionSetting.LOAD_SHOP_GAME_ROUND_OPTION_SETTING_INFO_REQUEST]: (state, action) => {
    state.error = INITIAL_STATE.error;
  },
  [ShopGameRoundOptionSetting.LOAD_SHOP_GAME_ROUND_OPTION_SETTING_INFO_REQUEST_SUCCESS]: (state, action) => {
    state.data.concede = action.payload.concede;
    state.data.holeCupLocation = action.payload.holeCupLocation;
    state.data.mulliganCount = action.payload.mulliganCount;
    state.data.useSwingPlate = action.payload.useSwingPlate;
    state.data.distanceUnit = action.payload.distanceUnit;
    state.data.greenLocation = action.payload.greenLocation;
    state.data.greenSpeed = action.payload.greenSpeed;
    state.data.greenHardness = action.payload.greenHardness === null ? 0 : action.payload.greenHardness;
    state.data.windSpeed = action.payload.windSpeed;
    state.data.puttingLine = action.payload.puttingLine;
    state.data.isBestVideo = action.payload.isBestVideo;
    // state.data.isContinuePutting = action.payload.isContinuePutting;
    state.data.isCaddyVoice = action.payload.isCaddyVoice;
    state.data.isNoPuttMode =
      action.payload.isNoPuttMode === null || action.payload.isNoPuttMode === undefined ? false : action.payload.isNoPuttMode;
    state.data.isUseObHazardTee = action.payload.isUseObHazardTee;
    state.data.shotInfoLocation = action.payload.shotInfoLocation;
    state.data.isUseGuideDistance = action.payload.isUseGuideDistance === null ? false : action.payload.isUseGuideDistance;
    state.data.maxScoreFactor = action.payload.maxScoreFactor;
  },
  [ShopGameRoundOptionSetting.LOAD_SHOP_GAME_ROUND_OPTION_SETTING_INFO_REQUEST_FAILURE]: (state, action) => {
    state.error = {
      triggered: true,
      message: action.payload,
    };
  },

  [ShopGameRoundOptionSetting.EDIT_SHOP_GAME_ROUND_OPTION_SETTING_INFO_REQUEST]: (state, action) => {
    state.error = INITIAL_STATE.error;
  },
  [ShopGameRoundOptionSetting.EDIT_SHOP_GAME_ROUND_OPTION_SETTING_INFO_REQUEST_SUCCESS]: (state, action) => {},
  [ShopGameRoundOptionSetting.EDIT_SHOP_GAME_ROUND_OPTION_SETTING_INFO_REQUEST_FAILURE]: (state, action) => {
    state.error = {
      triggered: true,
      message: action.payload,
    };
  },
});

export default reducer;
